import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode } from "vue"

import { computed, ref } from "vue";
import { TraceLinkApprovalProps } from "@/types";
import { linkStatus } from "@/util";
import { editTraceStore, permissionStore, traceApiStore } from "@/hooks";
import {
  FlexBox,
  TextButton,
  Separator,
  IconButton,
} from "@/components/common";


/**
 * Displays trace link approval buttons.
 */
const __default__ = {
  name: "TraceLinkApproval",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    deletable: { type: Boolean },
    trace: {}
  },
  emits: ["approve", "decline", "unreview", "delete"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

// Loading state is kept local to allow for multiple trace approval rows to display at once.
const approveLoading = ref(false);
const declineLoading = ref(false);
const unreviewLoading = ref(false);

const displayActions = computed(() =>
  permissionStore.isAllowed("project.edit_data")
);

const showApprove = computed(() => linkStatus(props.trace).canBeApproved());
const showDecline = computed(() => linkStatus(props.trace).canBeDeclined());
const showUnreview = computed(() => linkStatus(props.trace).canBeReset());

/**
 * Approves the given link and updates the stored links.
 */
function handleApprove() {
  approveLoading.value = true;
  traceApiStore.handleApprove(props.trace, {
    onSuccess: () => emit("approve"),
    onComplete: () => (approveLoading.value = false),
  });
}

/**
 * Declines the given link and updates the stored links.
 */
function handleDecline() {
  declineLoading.value = true;
  traceApiStore.handleDecline(props.trace, {
    onSuccess: () => emit("decline"),
    onComplete: () => (declineLoading.value = false),
  });
}

/**
 * Unreviews the given link and updates the stored links.
 */
function handleUnreview() {
  unreviewLoading.value = true;
  traceApiStore.handleUnreview(props.trace, {
    onSuccess: () => emit("unreview"),
    onComplete: () => (unreviewLoading.value = false),
  });
}

/**
 * Edits the given link.
 */
function handleEdit() {
  editTraceStore.openPanel(props.trace);
}

/**
 * Deletes the given link.
 */
function handleDelete() {
  traceApiStore.handleDelete(props.trace, {
    onSuccess: () => emit("delete"),
  });
}

return (_ctx: any,_cache: any) => {
  return (displayActions.value)
    ? (_openBlock(), _createBlock(_unref(FlexBox), {
        key: 0,
        justify: "between",
        align: "center",
        class: "width-max"
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(FlexBox), {
            align: "center",
            justify: "center"
          }, {
            default: _withCtx(() => [
              (showUnreview.value)
                ? (_openBlock(), _createBlock(_unref(IconButton), {
                    key: 0,
                    tooltip: "Un-Review",
                    loading: unreviewLoading.value,
                    "data-cy": "button-trace-unreview",
                    icon: "trace-unreview",
                    onClick: handleUnreview
                  }, null, 8, ["loading"]))
                : _createCommentVNode("", true),
              (showApprove.value)
                ? (_openBlock(), _createBlock(_unref(IconButton), {
                    key: 1,
                    tooltip: "Approve",
                    loading: approveLoading.value,
                    "data-cy": "button-trace-approve",
                    icon: "trace-approve",
                    color: "primary",
                    onClick: handleApprove
                  }, null, 8, ["loading"]))
                : _createCommentVNode("", true),
              (showDecline.value)
                ? (_openBlock(), _createBlock(_unref(IconButton), {
                    key: 2,
                    tooltip: "Decline",
                    loading: declineLoading.value,
                    "data-cy": "button-trace-decline",
                    icon: "trace-decline",
                    color: "negative",
                    onClick: handleDecline
                  }, null, 8, ["loading"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          (props.deletable)
            ? (_openBlock(), _createBlock(_unref(FlexBox), { key: 0 }, {
                default: _withCtx(() => [
                  (showApprove.value || showDecline.value)
                    ? (_openBlock(), _createBlock(_unref(Separator), {
                        key: 0,
                        vertical: "",
                        x: "1"
                      }))
                    : _createCommentVNode("", true),
                  _createVNode(_unref(TextButton), {
                    text: "",
                    label: "Edit",
                    icon: "edit",
                    "data-cy": "button-trace-edit",
                    onClick: handleEdit
                  }),
                  _createVNode(_unref(TextButton), {
                    text: "",
                    label: "Delete",
                    icon: "delete",
                    "data-cy": "button-trace-delete",
                    onClick: handleDelete
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}
}

})